// AUTO-GENERATED — do not edit. Run `pnpm build` in packages/domain-data.
// Source: business/ishvaram/data/ai/personas/*.md (frontmatter)

/** Every AI Jyotishi persona id registered in the canonical persona store. */
export type PersonaId = "pandit_sharma";

/** Closed display-taxonomy of persona categories. */
export type PersonaCategory = "Vedic Astrologer";

/** Stable identity fields from persona frontmatter (display + routing). */
export interface PersonaMeta {
  id: PersonaId;
  name: string;
  title: string;
  category: PersonaCategory;
  specialization: string;
  gender: string;
  popular: boolean;
  avatar_url: string | null;
  lineage_text: string | null;
}

export const personas: readonly PersonaMeta[] = [
  {
    id: "pandit_sharma",
    name: "Pandit-ji",
    title: "Your AI Jyotishi",
    category: "Vedic Astrologer",
    specialization: "kundali_reading",
    gender: "male",
    popular: true,
    avatar_url: null,
    lineage_text: "Grounded in Brihat Parashara Hora Shastra · Swiss Ephemeris precision",
  },
] as const;

/** All persona ids, in filename order — for iteration / runtime validation. */
export const personaIds: readonly PersonaId[] = personas.map((p) => p.id);

export const personaMap: Readonly<Record<string, PersonaMeta>> = Object.fromEntries(
  personas.map((p) => [p.id, p])
);
